




















import { Component, Vue, Prop } from 'vue-property-decorator'
import FriendSelector from '@/components/FriendSelector.vue'
import QuestionList from '@/components/QuestionList.vue'
import QuestionButton from '@/components/QuestionButton.vue'
import CategoryLegend from '@/components/CategoryLegend.vue'
import QuestionCounter from '@/components/QuestionCounter.vue'

@Component({
  components: {
    FriendSelector,
    QuestionList,
    QuestionButton,
    QuestionCounter,
    CategoryLegend
  }
})
export default class QuestionsView extends Vue {
  get selectedFriend () {
    return this.$store.getters['selectedFriend']
  }

  get askedQuestionsList () {
    return this.$store.getters['askedQuestionsList']
  }
}
